import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SimpleBadge from "@/shared/components/utils/SimpleBadge.vue";
import { useAuthStore } from "@/auth/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationGroupBadge',
  setup(__props) {

const authStore = useAuthStore();

return (_ctx: any,_cache: any) => {
  return (_unref(authStore).isInSimulationMode)
    ? (_openBlock(), _createBlock(SimpleBadge, {
        key: 0,
        color: "orange",
        soft: "",
        "can-be-deleted": "",
        onDelete: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).stopSimulate()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" See interface as: " + _toDisplayString(_unref(authStore).groupSimulationName), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})